import React, { FunctionComponent } from 'react';
import { Platform, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { connect } from 'react-redux';
import { Icon } from '../../components';
import Theme from '../../theme';
import { addDeepLinkParams as addDeepLinkParamsAction } from '../../utils/notifications/actions';
import { defaultScale } from '../../utils/scaling';

interface IProps {
  navigation: any;
  continueSignupToken: string;
  goToStudioPreAccount(): void;
  t(key: string): string;
  addDeepLinkParams(param: { [key: string]: string }): void;
}

const StudioUserExistsError: FunctionComponent<IProps> = (
  {
    t,
    navigation,
    continueSignupToken,
    addDeepLinkParams,
  },
) => {
  const goToStudioPreAccount = () => {
    addDeepLinkParams({ continueSignupToken });
    if (Platform.OS === 'web') {
      navigation.navigate('HomeInstallAppScreen');
    } else {
      navigation.navigate('PreAccountSetPassword');
    }
  };

  return (
    <TouchableOpacity
      onPress={goToStudioPreAccount}
    >
      <View style={styles.errorContainer}>
        <Icon
          size={35}
          color={Theme.GREY_DARK}
          name='ios-alert-outline'
          style={{ paddingRight: 10 }}
        />
        <Text style={styles.message}>
          <Text>{t('studioAccountAlreadyExists')} </Text>
          <Text style={{ textDecorationLine: 'underline' }}>{t('here')}.</Text>
        </Text>
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  errorContainer: {
    flexDirection: 'row',
    marginVertical: defaultScale(10),
  },
  message: {
    flex: 1,
    fontSize: 14,
    flexWrap: 'wrap',
    fontFamily: Theme.CustomBold,
    color: Theme.GREY_DARK,
    paddingVertical: 3,
  },
});

const mapDispatchToProps = (dispatch) => ({
  addDeepLinkParams: (params) => dispatch(addDeepLinkParamsAction(params)),
});

export default connect(null, mapDispatchToProps)(StudioUserExistsError);
